import Navbar from "../components/Navbar";
import ProductList from "./ProductList";

const Dashboard = () => {
  return (
    <div>
      <Navbar />
      <ProductList />
    </div>
  );
};

export default Dashboard;
